export const partnerCourseGroups = {
  DataAnalysis: 'Data analysis',
};
